import React from 'react';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import _snakeCase from 'lodash/snakeCase';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { useModalStyles } from './styles';
import ReactJson from 'react-json-view';
import { useTheme } from '@lifeomic/chroma-react/styles';
import useFhirSearch, {
  Hits,
} from '../../../../../Surveys/util/FhirSearch/useFhirSearch';
import { ReferenceOrResource } from '../Attachment';

type UnknownAttachmentModalProps = {
  reference?: ReferenceOrResource;
  onDismiss: () => void;
};

export const UnknownAttachmentModal = (props: UnknownAttachmentModalProps) => {
  const { reference, onDismiss } = props;
  const theme = useTheme();
  const classes = useModalStyles();

  const [resourceType, resourceId] = (reference as fhir.Reference)?.reference
    ? (reference as fhir.Reference).reference!.split('/')
    : (reference as fhir.Resource).resourceType?.split('/') ?? [];
  const table = _snakeCase(resourceType);

  const [response, isLoading] = useFhirSearch<Hits<fhir.Resource>>({
    type: 'select',
    columns: '*',
    from: [{ table }],
    limit: [
      { type: 'number', value: 0 },
      { type: 'number', value: 1 },
    ],
    where: {
      type: 'elasticsearch',
      query: {
        bool: {
          must: [
            {
              term: {
                'id.keyword': resourceId,
              },
            },
          ],
        },
      },
    },
  });

  const resource = response?.hits?.hits[0]?._source;

  return (
    <Modal
      isFullScreen
      isOpen={true}
      onDismiss={onDismiss}
      contentClassName={classes.modalContent}
      data-testid="unknown-attachment-modal"
    >
      {isLoading ? (
        <Box fullWidth fullHeight justify="center" align="center">
          <DotLoader />
        </Box>
      ) : (
        <Box padding={4}>
          {resource ? (
            <ReactJson
              src={resource}
              style={{ fontFamily: theme.typography.fontFamily }}
              displayDataTypes={false}
              displayObjectSize={false}
            />
          ) : (
            <Box direction="column" gap={2}>
              <p>Attachment not found</p>
              {reference && (
                <ReactJson
                  src={reference ?? {}}
                  style={{ fontFamily: theme.typography.fontFamily }}
                  displayDataTypes={false}
                  displayObjectSize={false}
                />
              )}
            </Box>
          )}
        </Box>
      )}
    </Modal>
  );
};
